import { useCallback, useState } from 'react';

export interface ReorderingState {
  isReorderingMode: boolean;
  hasUnsavedChanges: boolean;
  enterReorderingMode: () => void;
  exitReorderingMode: () => void;
  setHasUnsavedChanges: (hasChanges: boolean) => void;
}

export const useReorderingState = (): ReorderingState => {
  const [isReorderingMode, setIsReorderingMode] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const enterReorderingMode = useCallback(() => {
    setIsReorderingMode(true);
  }, []);

  const exitReorderingMode = useCallback(() => {
    setIsReorderingMode(false);
    setHasUnsavedChanges(false);
  }, []);

  return {
    isReorderingMode,
    hasUnsavedChanges,
    enterReorderingMode,
    exitReorderingMode,
    setHasUnsavedChanges,
  };
};
